import React from 'react';
import { infoBarPropTypes } from './InfoBarPropTypes';
import Tooltip from '@Theme/natucare/components/Tooltip/Tooltip';
import DateDetails from '@Theme/natucare/components/Tooltip/modules/DateDetails/DateDetails';
import WhyTrustUs from '@Theme/natucare/components/Tooltip/modules/WhyTrustUs/WhyTrustUs';
import ReadingTime from './components/ReadingTime/ReadingTime';
import Date from './components/Date/Date';
import InfoBadge from './components/InfoBadge/InfoBadge';
import * as styles from './InfoBar.module.scss';
const InfoBar = ({
  activityDates,
  readingTime,
  badges
}) => {
  if (!readingTime && !activityDates && badges) {
    return null;
  }
  const {
    updatedAt,
    dateDetails
  } = activityDates;
  const hasDateDetails = dateDetails === null || dateDetails === void 0 ? void 0 : dateDetails.dates.some(({
    date
  }) => !!date);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootDates
  }, hasDateDetails ? /*#__PURE__*/React.createElement(Tooltip, {
    trigger: /*#__PURE__*/React.createElement(Date, {
      updatedAt: updatedAt
    })
  }, /*#__PURE__*/React.createElement(DateDetails, dateDetails)) : /*#__PURE__*/React.createElement(Date, {
    updatedAt: updatedAt
  }), /*#__PURE__*/React.createElement(ReadingTime, readingTime)), badges && /*#__PURE__*/React.createElement("div", {
    className: styles.rootBadges
  }, badges.map(({
    iconName,
    description,
    details
  }, index) => {
    const infoBadgeProps = {
      iconName,
      description
    };
    return details ? /*#__PURE__*/React.createElement(Tooltip, {
      trigger: /*#__PURE__*/React.createElement(InfoBadge, infoBadgeProps),
      key: index
    }, /*#__PURE__*/React.createElement(WhyTrustUs, details)) : /*#__PURE__*/React.createElement(InfoBadge, Object.assign({}, infoBadgeProps, {
      key: index
    }));
  })));
};
export default InfoBar;